import { CheckCircle2, AlertCircle, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import type { Recommendation } from "@/types";

const config: Record<Recommendation, { label: string; icon: typeof CheckCircle2; cls: string }> = {
  postular: {
    label: "POSTULAR",
    icon: CheckCircle2,
    cls: "bg-success/15 text-success border-success/30",
  },
  revisar: {
    label: "REVISAR",
    icon: AlertCircle,
    cls: "bg-warning/15 text-warning border-warning/30",
  },
  no_postular: {
    label: "NO POSTULAR",
    icon: XCircle,
    cls: "bg-destructive/15 text-destructive border-destructive/30",
  },
};

export function RecommendationBadge({
  value,
  size = "md",
}: {
  value: Recommendation;
  size?: "sm" | "md" | "lg";
}) {
  const c = config[value];
  const I = c.icon;
  const sizing =
    size === "sm"
      ? "text-[10px] px-1.5 py-0.5 gap-1"
      : size === "lg"
        ? "text-sm px-3 py-1.5 gap-2"
        : "text-xs px-2 py-1 gap-1.5";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border font-semibold uppercase tracking-wide",
        c.cls,
        sizing,
      )}
    >
      <I className={cn(size === "lg" ? "size-4" : size === "sm" ? "size-3" : "size-3.5")} />
      {c.label}
    </span>
  );
}
